var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    className: "undefined",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n  .icon-cancel{\n    fill:none;\n  }\n  .icon-cancel .b{\n    fill:#F3F3F3;\n  }\n  .icon-cancel .c{\n    stroke-linejoin:round;\n    stroke:#646464;\n  }\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon-cancel"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    className: "b"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 14L14 26",
    className: "undefined"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26 26L14 14",
    className: "undefined"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCancel);
export default __webpack_public_path__ + "static/media/icCancel.b3df85c84f30fb9e7cb2ce7aba8e50fd.svg";
export { ForwardRef as ReactComponent };